import React from "react";
import { Link, useLocation } from "react-router-dom";

const LEGAL_LINKS = [
  { slug: "aviso-legal", label: "Aviso legal" },
  { slug: "privacidad", label: "Política de privacidad" },
  { slug: "cookies", label: "Política de cookies" },
  { slug: "condiciones", label: "Condiciones de contratación" },
  { slug: "cancelaciones", label: "Cancelaciones y reembolsos" },
  { slug: "contacto", label: "Contacto" },
];

export const Footer = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <nav className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-slate-500">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.slug}
              to={`/legal/${l.slug}`}
              data-testid={`footer-link-${l.slug}`}
              className="hover:text-[#003284] underline-offset-4 hover:underline transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="mt-5 flex flex-col items-center gap-1 text-center">
          <p className="text-xs text-slate-400">Actividades Grupos de Empresa · operado por Sporty People</p>
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} Sporty People. Todos los derechos reservados.</p>
          <p className="text-[11px] text-slate-400 flex items-center gap-1.5">Pagos seguros con Stripe · Tarjeta, Google&nbsp;Pay, Apple&nbsp;Pay y PayPal</p>
        </div>
      </div>
    </footer>
  );
};
